import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '../../../IconButton';
import { CLOSE_START } from '../../modules/status';

export const getOnCloseButtonClickHandler = ({ id, setStatus }) => () => (
  setStatus({ id, status: CLOSE_START })
);

const ModalCloseButton = ({
  closeIconSrc,
  setStatus,
  id,
}) => (
  <div className="modal__close-button-container">
    <div className="grid-container">
      <div className="grid-x align-right">
        <IconButton
          onClick={getOnCloseButtonClickHandler({ id, setStatus })}
          iconSrc={closeIconSrc}
          size="small"
          extraClass="modal__close-button"
        />
      </div>
    </div>
  </div>
);

ModalCloseButton.propTypes = {
  closeIconSrc: PropTypes.string.isRequired,
  setStatus: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default ModalCloseButton;
